import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux'
import { useHistory, useLocation } from 'react-router-dom';
import _ from 'underscore'
import { initUrlParams, stringifySearch } from '../../../../utils';
import styles from './index.module.scss';

function Pagination() {

  const history = useHistory();
  const { pathname } = useLocation();

  const {
    allData,
    urlParams,
  } = useSelector(state => state.searchReducer)

  const [groupCount, setGroupCount] = useState(5); // eslint-disable-line
  const [startPage, setStartPage] = useState(1); // 这个指的是分组后的第一个开始页号码


  useEffect(() => {
    const { currPage } = allData;
    if(currPage >= groupCount){
      setStartPage(currPage - 2);
    }else{
      setStartPage(1)
    }
  }, [allData])

  const handlePrePageClick = () => {
    const { currPage } = allData;
    if (currPage == 1) return;
    handlePageClick(currPage - 1);
  }

  const handlePageClick = (currPage) => {
    const _searchParamsBody = JSON.parse(JSON.stringify(urlParams));
    // initUrlParams(_searchParamsBody, true)
    _searchParamsBody.page = currPage;
    history.push({
      pathname,
      search: stringifySearch(_searchParamsBody)
    })
  }

  const handleNextPageClick = () => {
    const { currPage, totalPage } = allData;
    if (currPage == totalPage) return;
    handlePageClick(currPage + 1)
  }

  const showPageList = () => {
    const { currPage, totalPage } = allData;
    const pages = [];
    pages.push(<li className={`${styles["pn-prev"]} ${currPage == 1 ? styles.disabled : null}`} key={0} onClick={handlePrePageClick}><i>&lt;</i><em>上一页</em></li>)
    if (totalPage <= 10) {
      for (let i = 1; i <= totalPage; i++) {
        pages.push(<li key={i} className={currPage == i ? styles.curr : null} onClick={() => handlePageClick(i)}>{i}</li>)
      }
    } else {
      pages.push(<li className={currPage == 1 ? styles.curr : null} key={1} onClick={() => handlePageClick(1)}>1</li>)
      currPage >= groupCount && pages.push(<li className={styles["pn-break"]} key={-1}>...</li>)
      const pageLength = Math.min(groupCount + startPage, totalPage)
      for (let i = startPage; i < pageLength; i++) {
        if (i < totalPage && i > 1) {
          pages.push(<li className={currPage == i ? styles.curr : null} key={i} onClick={() => handlePageClick(i)}>{i}</li>)
        }
      }
      
      if(currPage + groupCount <= totalPage){
        pages.push(<li className="" key={-2}>...</li>)
      }
      //最后一页
      pages.push(<li className={currPage == totalPage ? styles.curr : null} key={totalPage} onClick={() => handlePageClick(totalPage)}>{totalPage}</li>)
    }
    //下一页
    pages.push(<li className={`${styles["pn-next"]} ${currPage == totalPage ? styles.disabled : null}`} onClick={handleNextPageClick} key={totalPage + 1}><em>下一页</em><i>&gt;</i></li>)

    return pages;
  }

  const handleInputKeyDown = (e) => {
    if (e.keyCode == 13) {
      const targetValue = e.target.value;
      const { totalPage } = allData;
      handlePageClick(targetValue > totalPage ? totalPage : targetValue)
    }
  }

  return (
    <>
      {
        allData?.totalPage ? (
          <div className={`${styles["page"]} clearfix`}>
            <div id="J_bottomPage" className={styles["p-wrap"]}>
              <ul className={styles["p-num"]}>
                {
                  showPageList()
                }
              </ul>
              <span className={styles["p-skip"]}>
                <em>共<b>{allData.totalPage}</b>页&nbsp;&nbsp;到第</em>
                <input
                  defaultValue={allData?.currPage ? allData.currPage : 1}
                  onKeyDown={handleInputKeyDown}
                  className={styles["input-txt"]}
                />
                <em>页</em>
              </span>
            </div>
          </div >
        ) : null
      }
    </>
  )
}

export default Pagination;